function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M16 2c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L16 4H6.65C6.338 4 6 4.41 6 5c0 .545.288.936.578.993L6.65 6H10l3.804-.002c.026-.005.053-.01.08-.013L14 5.98h4c.513 0 .936.39.993.892L19 6.99v14c0 .519-.386.946-.883 1.004L18 22H7.364c-1.81 0-3.264-1.5-3.36-3.362L4 18.444V5c0-1.559 1.057-2.897 2.484-2.994L6.65 2H16zm-1 11.998c0 .86-1.013 1.319-1.66.752L12 13.573l-1.34 1.177c-.618.542-1.572.146-1.653-.642L9 13.998V8H6.65c-.226 0-.443-.03-.65-.089v10.533c0 .81.554 1.455 1.235 1.528l.129.007L17 19.978V8l-2-.001zM13 8h-2v3.999l.34-.314c.346-.32.85-.346 1.221-.08l.098.08L13 12V8z"
});

var SvgBookmark = function SvgBookmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark.dbf95ab5.svg";
export { ForwardRef as ReactComponent };